// @flow
/**
 * Created by Mike Chung on 2/8/18.
 */
import React, {Children, Component} from "react";
import {Alert, Progress} from "reactstrap";

export type BootstrapStateProps = {
    complete: number,
    error: boolean
}

export type BootstrapDispatchProps = {
    bootstrapApp: () => any
}

export type BootstrapProps = BootstrapStateProps & BootstrapDispatchProps & {
    children: any
};

class Bootstrap extends Component<BootstrapProps> {

    componentDidMount() {
        this.props.bootstrapApp();
    }

    render() {

        if (this.props.error) {
            return (
                <div className={"d-flex align-items-center justify-content-center"}>

                    <Alert color="danger">
                        Sorry it seems something went wrong. Cannot bootstrap the application.
                    </Alert>
                </div>
            )
        } else if (this.props.complete < 1) {

            return (
                <div className={"d-flex align-items-center justify-content-center"}>
                        <Progress className={"w-75"} animated color="success" value={this.props.complete * 100}/>
                </div>
            );
        } else {
            return Children.only(this.props.children);
        }
    }

}

export default Bootstrap;


// WEBPACK FOOTER //
// ./src/components/app/Bootstrap.js